//COMPONENT MATERIAL
import { Alert, Snackbar } from "@mui/material";

//global state
import { setGlobalState, useGlobalState } from "../../utils/state";

const SnackBar = () => {
    const handleClose = (
        _,
        reason
    ) => {
        if (reason === "clickaway") {
            return;
        }

        setGlobalState("open", false);
    };

    //Variabili globali
    const [openSnackbar] = useGlobalState("open");
    const [type] = useGlobalState("type");
    const [message] = useGlobalState("message");

    return (
        <div>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={5000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={handleClose}
                    severity={type}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default SnackBar;